import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex overflow-auto h-55px mt-5 mb-10" }
const _hoisted_2 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Top Earner ")
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Top Reseller ")
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Top Directs ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/leaderboard/top-earner",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/leaderboard/top-consumer",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/leaderboard/top-directs",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
}